export const MIN_WINDOW_INNER_WIDTH = 640;
